import
  styled
from 'styled-components/macro';

export const Container = styled.div`
  display: flex;
`;